export default "__VITE_ASSET__DpDp_6BT__"